import type React from "react";
import { useShipperContractCreatProps } from "./fetch";
import { ShipperContractCreatePageUi } from "./ui/";

export const ShipperContractCreatePage: React.FC<{
  deliveryProposalOfferCargoIdStr: string | undefined;
}> = (params) => {
  const props = useShipperContractCreatProps(
    params.deliveryProposalOfferCargoIdStr,
  );
  return <ShipperContractCreatePageUi {...props} />;
};
